import { render, staticRenderFns } from "./bussiness.vue?vue&type=template&id=70ad9bc6&scoped=true"
import script from "./bussiness.vue?vue&type=script&lang=js"
export * from "./bussiness.vue?vue&type=script&lang=js"
import style0 from "./bussiness.vue?vue&type=style&index=0&id=70ad9bc6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ad9bc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70ad9bc6')) {
      api.createRecord('70ad9bc6', component.options)
    } else {
      api.reload('70ad9bc6', component.options)
    }
    module.hot.accept("./bussiness.vue?vue&type=template&id=70ad9bc6&scoped=true", function () {
      api.rerender('70ad9bc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/softBusinessLogistics/bussiness.vue"
export default component.exports